// extracted by mini-css-extract-plugin
module.exports = {"raceContainer":"_4bba346","leaderboard":"_0e38a3d","table":"_df719b4","header":"_b61b3c4"};